// extracted by mini-css-extract-plugin
module.exports = {"logo":"BasicLogo-logo-17dd","svg":"BasicLogo-svg-17dd"};